import { Box, Group, Button } from '@mantine/core'
import { IconFileText, IconSettings, IconVolume, IconVolumeOff } from '@tabler/icons-react'
import { useSetAtom, useAtomValue } from 'jotai'
import { SectionLabel } from './SectionLabel'
import { speechSettingsAtom, activeSpeechStoryIdAtom, autoPlayResolvedAtom } from '../../atoms/speechAtoms'

// Pinned bottom of the Context Rail. Docs (when the story has player-visible
// documents) opens as a rail takeover. Speak toggles auto-play for the current
// story (a per-story override). Settings opens the full settings modal.
export function UtilityTray({ hasDocuments, onOpenDocs, onOpenSettings }) {
  const setSpeech = useSetAtom(speechSettingsAtom)
  const activeStoryId = useAtomValue(activeSpeechStoryIdAtom)
  const autoPlayOn = useAtomValue(autoPlayResolvedAtom)

  // Flip auto-play for THIS story via the per-story override. We write an
  // explicit 'on'/'off' (not 'use default') so the quick toggle is unambiguous.
  const toggleStoryAutoPlay = () => {
    if (!activeStoryId) return
    setSpeech((s) => ({
      ...s,
      perStoryAutoPlay: { ...(s.perStoryAutoPlay || {}), [activeStoryId]: autoPlayOn ? 'off' : 'on' },
    }))
  }

  return (
    <Box p="md" mt="auto" style={{ borderTop: '1px solid var(--bw-panel-border)' }}>
      <SectionLabel>Utility</SectionLabel>
      <Group gap="xs">
        {hasDocuments && (
          <Button size="xs" variant="default" leftSection={<IconFileText size={14} />} onClick={onOpenDocs}>
            Docs
          </Button>
        )}
        {activeStoryId && (
          <Button
            size="xs"
            variant={autoPlayOn ? 'light' : 'default'}
            color={autoPlayOn ? 'cyan' : undefined}
            leftSection={autoPlayOn ? <IconVolume size={14} /> : <IconVolumeOff size={14} />}
            onClick={toggleStoryAutoPlay}
            aria-label={autoPlayOn ? 'Turn off auto-play for this story' : 'Turn on auto-play for this story'}
          >
            {autoPlayOn ? 'Speak: on' : 'Speak: off'}
          </Button>
        )}
        <Button size="xs" variant="default" leftSection={<IconSettings size={14} />} onClick={onOpenSettings}>
          Settings
        </Button>
      </Group>
    </Box>
  )
}
